import React from "react";

const FacebookEvents = () => (
  <iframe
    title="facebookEvents"
    src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fhelsinkiwritersgroup%2F&tabs=timeline&width=256&height=500&small_header=false&adapt_container_width=true&hide_cover=true&show_facepile=true&appId"
    height="500"
    width="256"
    scrolling="no"
    frameBorder="0"
    allowFullScreen={true}
    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
  ></iframe>
);

export default FacebookEvents;
